export default __webpack_public_path__ + "static/media/numbersinput_locked.3f984bc4.svg";